import { Group } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

export interface State {
    table: Group[];
    all: Group[];
    perWorkspace: Group [];
    singleGroup: {
        loaded: boolean;
        saved: boolean;
        group?: Partial<Group>;
    };
}

const initialState: State = {
    all: [],
    perWorkspace: [],
    singleGroup: {
        group: undefined,
        loaded: false,
        saved: false,
    },
    table: [],
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StoreTableGroups:
            return {
                ...state,
                table: action.groups
            };
        case ActionTypeNames.StoreAllGroups:
            return {
                ...state,
                all: action.groups,
            };
        case ActionTypeNames.ClearSingleGroup:
            return {
                ...state,
                singleGroup: {
                    group: undefined,
                    loaded: false,
                    saved: false,
                },
            };
            case ActionTypeNames.StoreGroupsPerWorkspace:
                return {
                        ...state,
                        perWorkspace: action.groups,
                    };
        case ActionTypeNames.StoreSingleGroup:
            return {
                ...state,
                singleGroup: {
                    group: action.group,
                    loaded: true,
                    saved: false,
                },
            };
        case ActionTypeNames.SavedSingleGroup:
            return {
                ...state,
                singleGroup: {
                    ...state.singleGroup,
                    saved: true,
                }
            };
        default:
            return state;
    }
}
